module.exports = __webpack_public_path__ + "img/appBg.80cf214b.svg";